import React from 'react';
import { Button, CloseIcon } from 'tuui';

export const ChatAgentSidebarCloseButton = ({ closeChat, testIdPrefix }) => {
    return (
        <Button
            size={Button.size.md}
            variant={Button.variant.text}
            onClick={closeChat}
            aria-label="Close"
            data-testid={`${testIdPrefix}-close-button`}
        >
            <CloseIcon />
        </Button>
    );
};
